import React from 'react';
import PropTypes from 'prop-types';
import { PSPModuleFactory } from 'components/psp/PSPModuleFactory';

import './PSPSection.scss';
import { toKebabCase } from '../../../lib/helpers';

export default function PSPSection({
	title,
	modules,
	background,
	noPaddingBottom,
	noPaddingTop,
	noPadding,
}) {
	// Use a slugified version of the title as the id
	const sectionId = toKebabCase(title);
	return (
		<section
			className={`psp-section ${sectionId} ${background ?? ''} ${
				noPaddingBottom ? 'no-padding-bottom' : ''
			} ${noPaddingTop ? 'no-padding-top' : ''} ${
				noPadding ? 'no-padding' : ''
			}`}
			id={sectionId}
		>
			{modules.map((module, index) => {
				const moduleClasses = [module.type];
				if (module.id) moduleClasses.push(toKebabCase(module.id));
				if (module.background) moduleClasses.push(module.background);

				return (
					<div
						// eslint-disable-next-line react/no-array-index-key
						key={`module-${index}`}
						className={moduleClasses.join(' ')}
					>
						<PSPModuleFactory
							type={module.type}
							props={module.props}
						/>
					</div>
				);
			})}
		</section>
	);
}

PSPSection.propTypes = {
	modules: PropTypes.arrayOf(PropTypes.object).isRequired,
	title: PropTypes.string.isRequired,
	background: PropTypes.string,
	noPaddingBottom: PropTypes.bool,
	noPaddingTop: PropTypes.bool,
	noPadding: PropTypes.bool,
};
